export const testimonials = [
  {
    name: 'Sarah J.',
    role: 'Registered Nurse · ICU',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/28f19598-3afb-427f-9161-d1185ce44049.jpg',
    quote:
      'I appreciate having the critical care concepts organized into one reference collection. The separate sections for monitoring, assessment, and laboratory concepts make it easier to navigate the material when I’m reviewing a topic. The worksheets also provide a useful structure for organizing my study notes.',
  },
  {
    name: 'Marcus T.',
    role: 'Critical Care RN',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/9899a09e-9b05-4009-9611-1f77a395b968.jpg',
    quote:
      'The visual tables are a helpful feature for studying complex subjects. I like being able to review definitions, compare related concepts, and then use the exercises to check my understanding. It feels more organized than working through disconnected notes.',
  },
  {
    name: 'Valeria P.',
    role: 'Nursing Student',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/4dad9464-5f67-414d-a38c-599a63c927bf.jpg',
    quote:
      'I wanted a more structured way to study hemodynamic monitoring. Having the concepts organized into a dedicated volume makes it easier to focus on the subject I’m reviewing. The educational exercises are a useful complement to the reference material.',
  },
  {
    name: 'Kevin L.',
    role: 'ICU Nurse',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6b9a0e00-938e-415a-bb49-f6687a236b2a.jpg',
    quote:
      'The case exercises give me an opportunity to review concepts instead of simply reading about them. I particularly like the questions that encourage me to consider what information is available, what is missing, and why context matters.',
  },
  {
    name: 'Priya S.',
    role: 'Registered Nurse · Step-Down Unit',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/786bab65-73d1-4d5e-8fef-f151236c52de.jpg',
    quote:
      'The quick-reference materials and worksheets are a useful addition to the main volumes. Having everything organized in a consistent format makes it easier to identify the topics I want to revisit during my continuing education.',
  },
  {
    name: 'Linda M.',
    role: 'Senior Critical Care RN',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/1a12cb2a-8496-42fd-b9fd-7b29c20c4249.jpg',
    quote:
      'Even after years in critical care, I like having a structured way to refresh concepts. The comparison tables and the interpretation mistakes library are a thoughtful reminder of why context matters. It fits easily into a short review session before a shift.',
  },
];
